import { Tabs, TabsItem } from '@issuu/ixu-react';
import { layoutMarginSmall } from '@issuu/silkscreen';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import { shouldShowAds } from '../../util/ads-utils';
import { AdsBelowReader } from '../Ads';
import { DocumentDetails } from '../DocumentDetails';
import { PublisherDetails } from '../DocumentDetails/PublisherDetails';
import { Title } from '../DocumentDetails/Title';
import DocumentContext from '../DocumentPage/DocumentContext';
import { ScreenReaderH2 } from '../ScreenReaderOnly';
import { StoriesInside } from '../StoriesInside';

const Root = styled.aside`
    width: 100%;
    grid-area: document-info;
`;

const Content = styled.div`
    width: 100%;
`;

const AdsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${layoutMarginSmall};
`;

type ActiveTab = 'articles' | 'detail';

type InfoTabProps = {
    tab: string;
    setTab: React.Dispatch<React.SetStateAction<ActiveTab>>;
};

const InfoTabs: React.FC<InfoTabProps> = ({ tab, setTab }: InfoTabProps) => {
    return (
        <Tabs spacing="normal" spacingTop="none">
            <TabsItem isActive={tab === 'detail'} key="detail" onClick={() => setTab('detail')}>
                Detail
            </TabsItem>
            <TabsItem
                isActive={tab === 'articles'}
                key="stories"
                onClick={() => setTab('articles')}
            >
                Stories Inside
            </TabsItem>
        </Tabs>
    );
};

export const DocumentInfo: React.FC = () => {
    const context = useContext(DocumentContext);
    const {
        appState: {
            currentLayout: { name: layout },
        },
        articleStorySummaries,
        crawler,
    } = context;
    const [tab, setTab] = useState<ActiveTab>(articleStorySummaries.length ? 'articles' : 'detail');
    const isTiny = layout === 'tiny';
    return (
        <Root aria-label="Document details">
            {isTiny ? (
                <>
                    <ScreenReaderH2>Document details</ScreenReaderH2>
                    <PublisherDetails />
                    <Title />
                </>
            ) : null}
            {isTiny && shouldShowAds({ context }) ? (
                <AdsWrapper>
                    <AdsBelowReader />
                </AdsWrapper>
            ) : null}
            {articleStorySummaries.length && !crawler ? <InfoTabs {...{ tab, setTab }} /> : null}
            {crawler ? (
                <Content>
                    <DocumentDetails />
                    <StoriesInside />
                </Content>
            ) : (
                <Content>{tab === 'articles' ? <StoriesInside /> : <DocumentDetails />}</Content>
            )}
        </Root>
    );
};
